import { LoadingLazyComponents } from 'ict24h-themes-react'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { lazy } from 'react'
import { Navigate, Routes } from 'react-router-dom'
import {
  PROJECT_DEPARTMENT_PREFIX_URL,
  PROJECT_GENERAL_PREFIX_URL,
  PROJECT_MY_TASKS_PREFIX_URL,
  PROJECT_TEMPLATE_PREFIX_URL,
} from './constants/config.project'
import mapRouterHelper from '../../../../utils/MapRouterHelper'
import ProjectMemberRouters from './modules/project-member/ProjectMember.Routers'
import ProjectTrashRouters from './modules/project-trash/ProjectTrash.Routers'
import ProjectTaskRouters from './modules/project-task/ProjectTask.Routers'
import LayoutDetailProject from './pages/Layout.DetailProject'
import MyTasksRouters from './modules/project-task/MyTasks.Routers'
import LayoutMyTasks from './pages/Layout.MyTasks'
import prefixToPath from '../../../../utils/prefix-to-path'

const ListPageDepartmentProject = lazy(
  () => import('./pages/ListPage.Department.Project')
)
const ListPageGeneralProject = lazy(
  () => import('./pages/ListPage.General.Project')
)
const ListPageTemplateProject = lazy(
  () => import('./pages/ListPage.Template.Project')
)

const LayoutDetailTemplateProject = lazy(
  () => import('./pages/Layout.DetailTemplateProject')
)

const ProjectRouters: AppRouterItem[] = [
  {
    path: `/`,
    element: <Navigate to={prefixToPath(PROJECT_MY_TASKS_PREFIX_URL)} />,
  },
  {
    path: `${PROJECT_DEPARTMENT_PREFIX_URL}`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPageDepartmentProject />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${PROJECT_DEPARTMENT_PREFIX_URL}/:projectId/*`,
    element: (
      <LayoutDetailProject>
        <Routes>
          {mapRouterHelper(ProjectMemberRouters)}
          {mapRouterHelper(ProjectTrashRouters)}
          {mapRouterHelper(ProjectTaskRouters)}
        </Routes>
      </LayoutDetailProject>
    ),
  },
  {
    path: `${PROJECT_GENERAL_PREFIX_URL}`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPageGeneralProject />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${PROJECT_GENERAL_PREFIX_URL}/:projectId/*`,
    element: (
      <LayoutDetailProject>
        <Routes>
          {mapRouterHelper(ProjectMemberRouters)}
          {mapRouterHelper(ProjectTrashRouters)}
          {mapRouterHelper(ProjectTaskRouters)}
        </Routes>
      </LayoutDetailProject>
    ),
  },
  {
    path: `${PROJECT_TEMPLATE_PREFIX_URL}`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPageTemplateProject />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${PROJECT_TEMPLATE_PREFIX_URL}/:projectId/*`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <LayoutDetailTemplateProject>
          <Routes>{mapRouterHelper(ProjectTaskRouters)}</Routes>
        </LayoutDetailTemplateProject>
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${PROJECT_MY_TASKS_PREFIX_URL}/*`,
    element: (
      <LayoutMyTasks>
        <Routes>
          {mapRouterHelper(ProjectTrashRouters)}
          {mapRouterHelper(MyTasksRouters)}
        </Routes>
      </LayoutMyTasks>
    ),
  },
]

export default ProjectRouters
